/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */

import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";

interface TaskDetailsData {
  description: string;
  duration: string;
  isCore?: boolean;
  lastUpdatedByUserId?: string;
  lastUpdatedByUserType?: BaseUserType;
  linkedNoteId?: string;
  linkedSurveyId?: string;
  patientExternalId: string;
  patientName?: string;
  selectedUserId: string;
  taskId: string;
  taskStatus: string;
  taskSubCategoryName: string;
  taskType: string;
  title: string;
}

interface TaskDetailsModalSliceState {
  taskDetailsData?: TaskDetailsData;
}

const initialState: TaskDetailsModalSliceState = {
  taskDetailsData: undefined,
};

const taskDetailsModalSlice = createSlice({
  // NOTE: extraReducers is required for resetAllReduxSlices to work as expected
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "taskDetailsModal",
  reducers: {
    resetTaskDetailsData: (state) => {
      state.taskDetailsData = undefined;
    },
    setTaskDetailsData: (state, action: PayloadAction<TaskDetailsData>) => {
      state.taskDetailsData = action.payload;
    },
  },
});

const {
  resetTaskDetailsData: resetTaskDetailsDataAction,
  setTaskDetailsData: setTaskDetailsDataAction,
} = taskDetailsModalSlice.actions;

const selectTaskDetailsData = (state: RootState) =>
  state.taskDetailsModal.taskDetailsData;

const useTaskDetailsModalDispatch = () => {
  const dispatch = useAppDispatch();

  const resetTaskDetailsData = () => {
    dispatch(resetTaskDetailsDataAction());
  };

  const setTaskDetailsData = (data: TaskDetailsData) => {
    dispatch(setTaskDetailsDataAction(data));
  };

  return {
    resetTaskDetailsData,
    setTaskDetailsData,
  };
};

export {
  resetTaskDetailsDataAction,
  selectTaskDetailsData,
  setTaskDetailsDataAction,
  useTaskDetailsModalDispatch,
};
export type { TaskDetailsData, TaskDetailsModalSliceState };
export default taskDetailsModalSlice.reducer;
